import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Footer from './inc/Footer';

class App extends Component {
    constructor(){
        super();
        this.state = {
            userId:"",
            user :{}
        };
    }
	
    componentWillMount(){

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId:data.key,
                        user:data.val()
                      });

                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        }); 
    }


    componentWillUnMount(){
      this.listener()
    }

    render() {
      
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar   />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js